<template>
  <div>
    <v-card>
      <v-card-title>
        <v-flex d-flex lg4>
          <center><img src="archivos/logo.png" width="100%"/></center>
        </v-flex>
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-title>
        <span class="headline">Ficha de pago</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <p>Se ha registrado la inscripción de:</p>
          <v-layout wrap v-for="item in lista.lista" :key="item[0]">
            <v-flex d-flex lg2>{{ item[0] }}</v-flex>
            <v-flex d-flex lg2>{{ item[1] }} ALUMNOS</v-flex>
            <v-flex d-flex lg2>= S/ {{ item[2] }}</v-flex>
          </v-layout>
          <br />
          <h3><span style="border-style: solid;">Total a pagar: S/ {{ lista.total }}</span></h3>
          <br />
          <p>Realice el pago en la Caja Los Andes <br />
            Nº Cuenta: 1690050021000000172008 <br />
            A nombre de: Ardiles Nuñez Wilber A.
          </p>
          <p>Para más información de lugares de pago visite: <a target="_blank" href="http://cajarurallosandes.com/web/category/ubicacion/">http://cajarurallosandes.com</a></p>
        </v-container>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>
        <span class="headline">Pagos</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <table style="width: 100%">
            <thead>
              <tr align="left">
                <th>Número de operación</th>
                <th>Monto</th>
                <th>Estado</th>
                <th>Voucher</th>
              </tr>
            </thead>
            <tbody v-for="item in datos.data" :key="item[0]">
              <tr>
                <td style="vertical-align: text-top;">{{ item.fila[1] }}</td>
                <td style="vertical-align: text-top;">S/ {{ item.fila[2] }}</td>
                <td style="vertical-align: text-top;">{{ estados[item.fila[3]] }}</td>
                <td><img style="max-width: 100%" :src="mostrarVoucher(item.fila[4])"/></td>
              </tr>
            </tbody>
          </table>
          <br />
          <br /><br />
        </v-container>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>
        <span class="headline">Informar pago</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <p><b>Debe ingresar el número de operación, monto y adjuntar una foto de su voucher para poder validar el pago.</b></p>
            <p>Puede ubicar el número de operación en la parte superior derecha del voucher: &nbsp; <img src="../assets/voucher.jpeg" width="384px"/></p>
          </v-layout>
          <br /><br />
          <table style="width: 100%">
            <thead>
            </thead>
            <tbody>
              <tr>
                <td style="vertical-align: text-top;"><v-text-field label="Número de operación" v-model="registro.operacion" :rules="operacionRegla" mask="########"></v-text-field></td>
                <td style="vertical-align: text-top;"><v-text-field label="Monto" v-model="registro.monto" :rules="requeridoRegla" v-money></v-text-field></td>
                <td style="vertical-align: text-top;"><v-btn color="primary" @click="subirVoucher()">Adjuntar voucher</v-btn>
      					<input
      						type="file"
      						style="display: none"
      						ref="image"
      						accept="image/*"
      						@change="onSubirVoucher"
      					></td>
                <td><img style="max-width: 100%" :src="mostrarVoucher(voucherURL)"/></td>
                <td style="vertical-align: text-top;"><v-btn color="primary" @click="registrarPago()">Guardar</v-btn></td>
              </tr>
            </tbody>
          </table>
          <br />
        </v-container>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [
      { text: 'Apellido paterno', value: 0 },
      { text: 'Apellido materno', value: 1 },
      { text: 'Nombres', value: 2 },
      { text: 'DNI', value: 3 },
      { text: 'Teléfono', value: 4 },
      { text: 'Correo', value: 5 },
      { text: 'Colegio', value: 6 },
      { text: 'Grado', value: 7 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {},
    lista: {},
    estados: ['', 'Por verificar', 'Procesado'],
    requeridoRegla: [
      v => !!v || 'Requerido'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    emailRegla: [
      v => !!v || 'Correo es requerido',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
    ],
    voucherURL: '',
    voucherArchivo: ''
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.verRegistro()
    this.apiListaRegistros(0, 0, 1)
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      if (this.$route.params.idAlumno !== undefined) {
        datos.idAlumno = this.$route.params.idAlumno
      }
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    verRegistro () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {}
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno
      }
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.lista = datos.d
            this.disabledRegistro = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    registrarPago () {
      var totalPagar = this.lista.total
      for (var item in this.datos.data) {
        totalPagar -= this.datos.data[item].fila[2]
      }
      if (parseFloat(this.registro.monto) !== parseFloat(totalPagar.replace(/,/g, ''))) {
        alert('Monto no corresponde con lo que debe pagar: ' + totalPagar)
        return
      }
      var solicitudApi = this.crearSolicitud()
      if (this.registro.operacion === undefined || this.registro.monto === undefined || this.registro.voucher === undefined || this.registro.operacion === '' || this.registro.monto === '' || this.registro.voucher === '') {
        alert('Debe llenar todos los campos')
      } else if (this.registro.monto === '0.00') {
        alert('Monto no puede ser 0')
      } else {
        solicitudApi.datos = this.registro
        if (this.$route.params.idAlumno !== undefined) {
          solicitudApi.datos.idAlumno = this.$route.params.idAlumno
        }
        const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.$emit('login', datos.m)
            } else {
              if (datos.e === 1) {
                let descendente = 0
                if (this.pagination.descending) {
                  descendente = 1
                }
                this.registro = {}
                this.voucherURL = ''
                this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
              } else {
                alert(datos.m)
              }
            }
          })
      }
    },
    subirVoucher () {
      this.$refs.image.click()
    },
    registrarVoucher (url, archivo) {
      this.voucherURL = url
      this.registro.voucher = encodeURIComponent(url)
      this.voucherArchivo = archivo
    },
    mostrarVoucher (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirVoucher (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 400
            var MAX_HEIGHT = 400
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarVoucher(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.voucherArchivo = ''
        this.voucherURL = ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pago.vue